import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ToolBarAction from './toolbar-action';
import { connect } from 'react-redux';
import { getSelectedFolder } from '../../selectors/folders';
import { getCredentials } from '../../selectors/application';
import { FolderTypes } from '../../services/folder';
import { setShowFolderList } from '../../actions/folders';
import { deleteAllFolderMessages } from '../../services/message';
import ConfirmClearFolderDialog from './confirm-clear-folder-dialog';
import './list-toolbar.scss';

const ListActionButtons = props => {
  const [emptyTrashDialogOpen, setEmptyTrashDialogOpen] = useState(false);
  const { t } = useTranslation();
  const {
    selectedMessagesCounter,
    selectedMessagesAllUnread,
    markAsRead,
    markAsUnread,
    hideText,
    selectedMessages,
    onDeleteClick,
    clearFolder,
    selectedFolder,
    setShowFolderList,
  } = props;

  const handleReadUnread =
    selectedMessages.length > 0 && selectedMessagesAllUnread
      ? markAsRead
      : markAsUnread;
  const isTrash = selectedFolder.type === FolderTypes.TRASH;

  return (
    <div className={'toolbar-list-action-buttons'}>
      <div className="px-2">
        <ToolBarAction
          onClick={() => {}}
          icon="lf-icon lf-icon-reply"
          title={t('message-toolbar.reply')}
          disabled={true}
          hideText={hideText}
        />
      </div>
      <div className="px-2">
        <ToolBarAction
          onClick={() => null}
          icon="lf-icon lf-icon-reply-all"
          title={t('message-toolbar.reply-all')}
          disabled={true}
          hideText={hideText}
        />
      </div>
      <div className="px-2">
        <ToolBarAction
          onClick={() => {}}
          icon="lf-icon lf-icon-send"
          title={t('message-toolbar.resend')}
          disabled={true}
          hideText={hideText}
        />
      </div>
      <div className="px-2">
        <ToolBarAction
          onClick={handleReadUnread}
          icon="lf-icon lf-icon-mail-open"
          title={t('message-toolbar.read-unread')}
          disabled={selectedMessagesCounter === 0}
          hideText={hideText}
        />
      </div>
      <div className="">
          <ToolBarAction
            id="move-to-folder-popover"
            onClick={() => setShowFolderList(true)}
            icon="lf-icon-folder"
            title={t("message-toolbar.move-to")}
            disabled={selectedMessagesCounter === 0}
            hideText={hideText}
          />
      </div>
      <div className="px-2">
        <ToolBarAction
          onClick={() => {}}
          icon="lf-icon lf-icon-print"
          title={t('message-toolbar.print')}
          disabled={true}
          hideText={hideText}
        />
      </div>
      {!isTrash && (
        <div className="px-2">
          <ToolBarAction
            onClick={onDeleteClick}
            icon="lf-icon lf-icon-trash"
            title={t('message-toolbar.move-to-trash')}
            disabled={selectedMessagesCounter === 0}
            hideText={hideText}
          />
        </div>
      )}
      {isTrash && (
        <div className="px-2">
          <ToolBarAction
            onClick={() => setEmptyTrashDialogOpen(true)}
            icon="lf-icon lf-icon-trash"
            title={t('message-toolbar.empty-trash')}
            hideText={hideText}
          />
        </div>
      )}
      <ConfirmClearFolderDialog
        visible={emptyTrashDialogOpen}
        cancelAction={() => setEmptyTrashDialogOpen(false)}
        deleteAction={() => {
          clearFolder();
          setEmptyTrashDialogOpen(false);
        }}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  credentials: getCredentials(state),
  selectedFolder: getSelectedFolder(state) || {}
});

const mapDispatchToProps = dispatch => ({
  clearFolder: (credentials, folder) =>
    deleteAllFolderMessages(dispatch, credentials, folder),
  setShowFolderList: showFolderList => dispatch(setShowFolderList(showFolderList)),
});

const mergeProps = (stateProps, dispatchProps, ownProps) =>
  Object.assign({}, stateProps, dispatchProps, ownProps, {
    clearFolder: () =>
      dispatchProps.clearFolder(
        stateProps.credentials,
        stateProps.selectedFolder
      )
  });

const ConnectedListActionButtons = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(ListActionButtons);

export default ConnectedListActionButtons;
